import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';

export default function Hero({ title, subtitle, ctaText='Request Service', ctaLink='/book', bgImage='/assets/images/hero-home.svg' }) {
  return (
    <Box sx={{
      minHeight: { xs: 360, md: 480 },
      backgroundImage: `url(${bgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover', backgroundPosition: 'center',
      display: 'flex', alignItems: 'center'
    }}>
      <Container maxWidth="lg">
        <Stack spacing={2} sx={{ bgcolor: 'rgba(255,255,255,0.85)', p: 3, borderRadius: 2, maxWidth: 760 }}>
          <Typography variant="h1">{title}</Typography>
          <Typography variant="h5" color="text.secondary">{subtitle}</Typography>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="primary" href={ctaLink}>{ctaText}</Button>
            <Button variant="outlined" color="primary" href="tel:+18125550168">Emergency: (812) 555-0168</Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
